import { MdOutlineImage } from 'react-icons/md';
import { MIcon, MImage, MSkeleton } from '../../../../components/Monetize';
import { useLegalEntityLogo } from '../../../../hooks/useLegalEntityLogo';

interface LegalEntityLogoCellProps {
  id: string;
  name: string;
}

export const LegalEntityLogoCell = ({ id, name }: LegalEntityLogoCellProps) => {
  const { isLoading, base64 } = useLegalEntityLogo({ id });

  if (isLoading) {
    return <MSkeleton h={6} w={10} />;
  }

  if (base64) {
    return <MImage maxH={6} maxW={12} src={base64} alt={`${name} logo`} />;
  }

  return <MIcon as={MdOutlineImage} boxSize={6} color="fg.muted" />;
};
